export default __webpack_public_path__ + "static/media/robot_sorry.4455f257.png";